<template>
  <gj-modal
      :visible.sync="modalVisible"
      v-bind="$attrs"
      v-on="$listeners"
      size="650_auto"
      no-padding
      @close="cancel"
  >
    <template #header>
      提示
    </template>
    <template #content>
      <div style="padding: 18px 20px 10px;">

        <gj-alert type="info" show-icon>
          <template #title>
            系统检测您已超过90天未修改密码，为了您帐号更安全，建议立即进行更换
          </template>
        </gj-alert>

        <div class="flex justify-between" style="padding: 33px 26px 0 100px;">

          <div class="color333">
            <div class="size16" style="padding: 44px 0 38px;">更换密码可以：</div>
            <div class="size14" style="padding-left: 4px;">1.提高您的账户安全性</div>
            <div class="size14" style="padding: 9px 0 0 4px;">2.防止密码被盗</div>
          </div>

          <img src="./img/password-expired.png">

        </div>

      </div>
    </template>
    <template #footer>
      <gj-button
          class="btn"
          style="color: #999;font-size: 12px;"
          @click="cancel"
          type="text"
      >我知道了
      </gj-button>
      <gj-button
          class="btn"
          type="primary"
          @click="confirm"
      >修改密码
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import EditPassword from "@/views/modules/personal-center/personal-center/edit-password";

export default {
  name: "password-expired",
  mixins: [modalMixIn],
  methods: {
    confirm() {
      this.modalVisible = false;
      this.$gjCreate(EditPassword)
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  width: 74px;
  height: 32px;
  padding: 0;
}
</style>